import React from 'react';
import './App.scss';
import { BrowserRouter } from 'react-router-dom';
import { PageRoutes } from "./routes/routes";
import { GTMProvider } from '@elgorditosalsero/react-gtm-hook';
import CookieConsent from "react-cookie-consent";
import { Box } from '@chakra-ui/react';

function App() {
  const gtmParams = {
    id: 'GTM-N2TCQ27',
    environment: {
      gtm_auth: 'WOwffLocmZYxIn81wK-xWg',
      gtm_preview: 'env-10'
    }
  }


  return (
    <>
      <GTMProvider state={gtmParams}>
        <Box h='100vh'>
          <BrowserRouter>
            <PageRoutes />
          </BrowserRouter>
        </Box>
      </GTMProvider>

      <CookieConsent buttonStyle={{background: "var(--Able-blue)", color: "white"}}>
        This website uses cookies to enhance the user experience.
        <p style={{fontSize: "12px"}}>By continuing to use this service, you accept the use of these cookies.</p>
      </CookieConsent>
    </>
  );
}

export default App;
